<template>
    <div>
        <b-overlay :show="loading">

            <b-card no-body>
                <b-tabs card>

                    <b-tab :title="__('import.betfair_ob_tab1')" active>

                        <p>
                            {{ __('import.betfair_ob_headline') }}
                        </p>

                        <ul class="mt-2">
                            <li>
                                {{ __('import.betfair_ob_l1')}}
                            </li>
                            <li>
                                {{ __('import.betfair_ob_l2')}}
                            </li>
                            <li>
                                <b>{{ __('import.betfair_ob_l3')}}</b>
                            </li>
                        </ul>

                        <div class="alert alert-success">

                            <p>{{ __('import.betfair_ob_btn_txt') }}</p>

                            <b-form-group :label="__('import.betfair_import_from')">
                                <b-select v-model="form.initial_date">
                                    <b-select-option value="90_days">
                                        {{ __('import.betfair_90 days') }}
                                    </b-select-option>
                                    <b-select-option value="next_bets">
                                        {{ __('import.betfair_next_bets') }}
                                    </b-select-option>
                                </b-select>
                            </b-form-group>

                            <b-form-group>
                                <b-button type="button" variant="success" @click="newBankroll">
                                    {{ __('import.betfair_start_bankroll') }}
                                </b-button>
                            </b-form-group>

                        </div>

                    </b-tab>

                    <b-tab :title="__('import.betfair_ob_tab2')">

                        <p>
                            {{ __('import.betfair_ob2_headline') }}
                        </p>

                        <ul class="mt-2">
                            <li>
                                {{ __('import.betfair_ob2_l1') }}
                            </li>
                            <li>
                                {{ __('import.betfair_ob2_l2') }}
                            </li>
                            <li>
                                <b>{{ __('import.betfair_ob2_l3') }}</b>
                            </li>
                        </ul>

                        <div class="alert alert-info">

                            <p>
                                {{ __('import.betfair_ob2_btn_txt') }}
                            </p>

                            <b-form-group :label="__('import.betfair_selec_bank')">
                                <b-select v-model="bankroll">
                                    <b-select-option value="">
                                        {{ __('import.betfair_empty_opt') }}
                                    </b-select-option>
                                    <b-select-option v-for="(item, key) of check.bankrolls" :key="key" :value="item.id">
                                        {{ item.name }}
                                    </b-select-option>
                                </b-select>
                            </b-form-group>

                            <b-form-group>
                                <b-button type="button" variant="primary" @click="selectBankroll">
                                    {{ __('import.betfair_btn_confirm') }}
                                </b-button>
                            </b-form-group>

                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
export default {
    props: ['locale'],
    data() {
        return {
            loading: false,
            check: {
                bankrolls: []
            },
            bankroll: '',
            form: {
                balance: 0,
                initial_date: '90_days',
            }
        }
    },
    mounted() {
        this.loadCheck();
        // $('.money').maskMoney();
    },
    methods: {

        /**
         * loadCheck
         */
        loadCheck() {
            this.loading = true
            axios
                .get('/betfair/onboarding-check')
                .then((result) => {
                    this.check = result;
                    this.loading = false
                })
                .finally(() => { this.loading = false })
        },

        /**
         * newBankroll
         */
        newBankroll() {
            this.loading = true
            axios
                .post('/' + this.locale + '/betfair/new-bankroll', this.form)
                .then((result) => {
                    location.href = '/' + this.locale + '/betfair/first-import?isFirstImportBetfair=true';
                })
                .finally(() => { this.loading = false })
        },

        /**
         * selectBankroll
         */
        selectBankroll() {
            if (this.bankroll !== '') {
                this.loading = true
                axios
                    .get('/' + this.locale + '/betfair/select-bankroll/' + this.bankroll)
                    .then(() => {
                        location.reload();
                    })
                    .finally(() => { this.loading = false })

            } else {
                alert(this.__('import.Select the bankroll you want to be integrated!'));
            }
        }
    }
}
</script>

<style>

</style>
